export type AddToProductTextField =
  | { kind: 'text'; field: 'title' | 'description' | 'keywords' | string; label: string; value: string; charLimit?: number }
  | { kind: 'bullets'; field: 'bullets'; label: string; values: string[]; charLimit?: number }

export interface AddToProductImage {
  id: string
  url: string
  width?: number
  height?: number
  kind: 'asset' | 'generated'
}

export type AddToProductTarget =
  | { type: 'channel'; channelId: string; slot: number }
  | { type: 'ai_reference'; slot: number }

export type DropTargetData =
  | { target: 'channel'; channelId: string; slot: number }
  | { target: 'ai_reference'; slot: number }

export interface AddToProductPayload {
  source: 'remake' | 'studio' | 'gallery'
  title: string
  texts?: AddToProductTextField[]
  images: AddToProductImage[]
  preselect?: { productId?: string; identifiers?: { sku?: string; gtin?: string; asin?: string } }
}

export function hasTexts(p: AddToProductPayload): boolean {
  return Array.isArray(p.texts) && p.texts.length > 0
}
